module.exports = __webpack_public_path__ + "static/media/02-1-galeria-01-dior@2x.e857d005.jpg";